import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SupabaseService } from '@libs/shared';

export const authGuard: CanActivateFn = async () => {
    const supabase = inject(SupabaseService);
    const router = inject(Router);

    const user = await supabase.getCurrentUser(); //

    if (user) {
        return true;
    }

    // Redirigir al login si no hay sesión
    return router.createUrlTree(['/auth']);
};